import { useEffect } from 'react';

interface UseFetchDataParams {
  isDataAndCurrentConfigEqual: boolean;
  onGetData: () => void;
}

export const useFetchData = ({
  isDataAndCurrentConfigEqual,
  onGetData,
}: UseFetchDataParams) => {
  useEffect(
    () => {
      if (isDataAndCurrentConfigEqual) {
        return;
      }

      onGetData();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isDataAndCurrentConfigEqual],
  );
};
